var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("layout-header", {
    attrs: { loading: _vm.loading },
    scopedSlots: _vm._u([
      {
        key: "icon",
        fn: function() {
          return [
            _c("router-link", { attrs: { to: "/" } }, [_c("icon-back")], 1)
          ]
        },
        proxy: true
      },
      {
        key: "title",
        fn: function() {
          return [
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ]
              },
              [_vm._v(_vm._s(_vm.loading))]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.loading,
                  expression: "!loading"
                }
              ],
              ref: "name",
              attrs: { type: "text", disabled: !_vm.editing },
              domProps: { value: _vm.template && _vm.template.name }
            })
          ]
        },
        proxy: true
      },
      {
        key: "buttons",
        fn: function() {
          return [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.loading,
                    expression: "!loading"
                  }
                ]
              },
              [
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.editing,
                        expression: "!editing"
                      }
                    ],
                    staticClass: "f-button default",
                    on: {
                      click: function($event) {
                        _vm.remove().then(_vm.removed)
                      }
                    }
                  },
                  [_vm._v("Delete")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.editing,
                        expression: "!editing"
                      }
                    ],
                    staticClass: "f-button primary",
                    on: {
                      click: function($event) {
                        return _vm.edit(true)
                      }
                    }
                  },
                  [_vm._v("Edit")]
                ),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.fresh && _vm.editing,
                        expression: "fresh && editing"
                      }
                    ],
                    staticClass: "f-button default",
                    attrs: { to: "/" }
                  },
                  [_vm._v("Cancel")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.fresh && _vm.editing,
                        expression: "fresh && editing"
                      }
                    ],
                    staticClass: "f-button primary",
                    on: {
                      click: function($event) {
                        _vm.create(_vm.name).then(_vm.created)
                      }
                    }
                  },
                  [_vm._v("Save")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.fresh && _vm.editing,
                        expression: "!fresh && editing"
                      }
                    ],
                    staticClass: "f-button default",
                    on: {
                      click: function($event) {
                        return _vm.cancel()
                      }
                    }
                  },
                  [_vm._v("Cancel")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.fresh && _vm.editing,
                        expression: "!fresh && editing"
                      }
                    ],
                    staticClass: "f-button primary",
                    on: {
                      click: function($event) {
                        _vm.update(_vm.name).then(_vm.updated)
                      }
                    }
                  },
                  [_vm._v("Save")]
                )
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }